module.exports = __webpack_public_path__ + "static/media/tbanner_slider1.347d4354.jpg";